import React from 'react'
import Eye from 'assets/images/onboarding/Eye.svg'
import Lock from 'assets/images/onboarding/Lock.svg'
import { useProfile } from 'hooks/useProfile'
import './style.scss'

const Privacy = () => {
    const { pilotTag } = useProfile()

    return (
        <div className="privateDataContainer">
            <div style={{ paddingBottom: 16 }}>
                <img src={Eye} alt="Eye" />
                <div>
                    <p>
                        <span>
                            <b>100% confidential </b>
                        </span>
                        <br />
                        <span> We’ll never share personal information with your manager or company</span>
                    </p>
                </div>
            </div>
            <div>
                <img src={Lock} alt="Lock" />
                <div>
                    <p>
                        <span>
                            <b> {pilotTag} only see anonymised data</b>
                        </span>
                        <br />
                        <span>They can see overall company wellbeing - but not how you use betterspace individually</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Privacy
